import Vue from 'vue';

// v-dialogDrag: 弹窗拖拽
Vue.directive('dialogDrag', {
    bind(el, binding, vnode, oldVnode) {
        const dialogHeaderEl = el.querySelector('.el-dialog__header');
        const dragDom = el.querySelector('.el-dialog');
        dialogHeaderEl.style.cursor = 'move';

        // 获取原有属性 ie dom元素.currentStyle 火狐谷歌 window.getComputedStyle(dom元素, null);
        const sty = dragDom.currentStyle || window.getComputedStyle(dragDom, null);
        
        dialogHeaderEl.onmousedown = (e) => {
            // 鼠标按下，计算当前元素距离可视区的距离
            const disX = e.clientX - dialogHeaderEl.offsetLeft;
            const disY = e.clientY - dialogHeaderEl.offsetTop;
            
            // 获取到的值带px 正则匹配替换
            let styL, styT;

            // 注意在ie中 第一次获取到的值为组件自带50% 移动之后赋值为px
            if(sty.left.includes('%')) {
                styL = +document.body.clientWidth * (+sty.left.replace(/\%/g, '') / 100);
                styT = +document.body.clientHeight * (+sty.top.replace(/\%/g, '') / 100);
            }else {
                styL = +sty.left.replace(/\px/g, '');
                styT = +sty.top.replace(/\px/g, '');
            };
            
            document.onmousemove = function (e) {
                // 通过事件委托，计算移动的距离 
                const l = e.clientX - disX;
                const t = e.clientY - disY;

                // 移动当前元素  
                dragDom.style.left = `${l + styL}px`;
                dragDom.style.top = `${t + styT}px`;

                //将此时的位置传出去
                //binding.value({x:e.pageX,y:e.pageY})
            };

            document.onmouseup = function (e) {
                document.onmousemove = null;
                document.onmouseup = null;
            };
        }  
    }
});

// v-dialogDragWidth: 弹窗宽度拖大 拖小
Vue.directive('dialogDragWidth', {
    bind(el, binding, vnode, oldVnode) {
        const dragDom = binding.value.$el.querySelector('.el-dialog');

        el.onmousedown = (e) => {
            
            // 鼠标按下，计算当前元素距离可视区的距离
            const disX = e.clientX - el.offsetLeft;
            
            document.onmousemove = function (e) {
                e.preventDefault(); // 移动时禁用默认事件

                // 通过事件委托，计算移动的距离 
                const l = e.clientX - disX;
                dragDom.style.width = `${l}px`;
            };

            document.onmouseup = function (e) {
                document.onmousemove = null;
                document.onmouseup = null;
            };
        }  
    }
});

// v-dialogDrag: 弹窗拖拽
// limit-in-screen 限制在屏幕内拖拽
Vue.directive('layerDrag', {
    bind(el, binding, vnode, oldVnode) {
        const layerHeaderEl = el.querySelector('.drag-layer-header');
        const dragDom = el.querySelector('.drag-layer-box');
        layerHeaderEl.style.cursor = 'move';
		
        // 获取原有属性 ie dom元素.currentStyle 火狐谷歌 window.getComputedStyle(dom元素, null);
        const sty = dragDom.currentStyle || window.getComputedStyle(dragDom, null);
        
        // 获取 是否限制拖拽范伟
        const elLimit = el.getAttribute('limit-in-screen');
        const layerHeaderElLimit = layerHeaderEl.getAttribute('limit-in-screen');
        const dragDomLimit = dragDom.getAttribute('limit-in-screen');
        const limitInScreenFlag = (elLimit === '' || elLimit === true) || (layerHeaderElLimit === '' || layerHeaderElLimit === true) || (dragDomLimit === '' || dragDomLimit === true);
        
        layerHeaderEl.onmousedown = (e) => {
            // 获取元素宽高
	        const dragDomW = dragDom.offsetWidth;
	        const dragDomH = dragDom.offsetHeight;
	        const layerHeaderElH = layerHeaderEl.offsetHeight;
	        
            // 鼠标按下，计算当前元素距离可视区的距离
            const disX = e.clientX - layerHeaderEl.offsetLeft;
            const disY = e.clientY - layerHeaderEl.offsetTop;
            
            // 获取到的值带px 正则匹配替换
            let styL, styT;

            // 注意在ie中 第一次获取到的值为组件自带50% 移动之后赋值为px
            if(sty.left.includes('%')) {
                styL = +document.body.clientWidth * (+sty.left.replace(/\%/g, '') / 100);
                styT = +document.body.clientHeight * (+sty.top.replace(/\%/g, '') / 100);
            }else {
                styL = +sty.left.replace(/\px/g, '');
                styT = +sty.top.replace(/\px/g, '');
            };
            
            // 移动 标志
            let movedFlag = false;
            document.onmousemove = function (e) {
                // 通过事件委托，计算移动的距离 
                let l = e.clientX - disX;
                let t = e.clientY - disY;
				
				if (limitInScreenFlag) {
					l = l + styL < 0 ? -styL : l + styL + dragDomW > +document.body.clientWidth ? +document.body.clientWidth - dragDomW - styL : l;
					t = t + styT < 0 ? -styT : t + styT + layerHeaderElH > +document.body.clientHeight ? +document.body.clientHeight - layerHeaderElH - styT : t;
				}
				
                // 移动当前元素  
                dragDom.style.left = `${l + styL}px`;
                dragDom.style.top = `${t + styT}px`;
				
				// 移动 标志
				if (!movedFlag) movedFlag = true;
				
                //将此时的位置传出去
                //binding.value({x:e.pageX,y:e.pageY})
            };

            document.onmouseup = function (e) {
                document.onmousemove = null;
                document.onmouseup = null;
                
                // 获取到的值带px 正则匹配替换
	            let styL, styT;
	
	            // 注意在ie中 第一次获取到的值为组件自带50% 移动之后赋值为px
	            if(sty.left.includes('%')) {
	                styL = +document.body.clientWidth * (+sty.left.replace(/\%/g, '') / 100);
	                styT = +document.body.clientHeight * (+sty.top.replace(/\%/g, '') / 100);
	            }else {
	                styL = +sty.left.replace(/\px/g, '');
	                styT = +sty.top.replace(/\px/g, '');
	            };
                
                //将此时的位置传出去
                movedFlag && binding.value({left:styL, top:styT});
            };
        }  
    }
});

// v-resize：元素宽高变化 
Vue.directive('resize', {
	bind(el, binding) {
		let _width = '', _height = '';
		function isReize() {
			const style = document.defaultView.getComputedStyle(el);
			var width = style.width, height = style.height;
			if (_width !== width || _height !== height) {
				binding.value({width, height}, style, el);  // 关键
			}
			_width = style.width;
			_height = style.height;
		}
		
		// 清除定时器
		if (el.__vueSetInterval__) clearInterval(el.__vueSetInterval__);
		
		el.__vueSetInterval__ = setInterval(isReize, 400);
	},
	unbind(el) {
		clearInterval(el.__vueSetInterval__);
	},
});




// WEBPACK FOOTER //
// ./src/components/utils/directives.js